import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/perfunnel-ui-v1_release_26.10.21@2/app/error.tsx");
